import axios from 'axios';
import querystring from 'querystring';
import {
    FETCH_LANG_SUCCESS,
} from '../constants/ActionTypes';

export const fetchLangSuccess = data => {
    return {
        type: FETCH_LANG_SUCCESS,
        payload: data
    }
}

export const fetchLang = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });
    
    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            dispatch(fetchLangSuccess(response.data));
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}